// kapigen version 0.1.34
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { createClient } from "../../../requestClientInternal";
import { DatabundleDiffTypeWireFormat3 as KaggleSdkDatasetsDatabundleDiffTypeWireFormat3, DatabundleStatusWireFormat3 as KaggleSdkDatasetsDatabundleStatusWireFormat3, DatabundleTypeWireFormat3 as KaggleSdkDatasetsDatabundleTypeWireFormat3, DatabundleVersionTypeWireFormat3 as KaggleSdkDatasetsDatabundleVersionTypeWireFormat3, DatasetUsabilityRatingWireFormat3 as KaggleSdkDatasetsDatasetUsabilityRatingWireFormat3, LicenseWireFormat3 as KaggleSdkDatasetsLicenseWireFormat3, RemoteUrlUpdateFrequencyWireFormat3 as KaggleSdkDatasetsRemoteUrlUpdateFrequencyWireFormat3, StorageLocationWireFormat3 as KaggleSdkDatasetsStorageLocationWireFormat3 } from "..";
import { ModelFrameworkWireFormat3 as KaggleSdkModelsModelFrameworkWireFormat3 } from "../../models";
// namespace Kaggle.Sdk.Datasets.Databundles:
export var DataSource;
(function(DataSource) {
    var defaultModelInfo = {
        isTfhubModel: false
    };
    var ModelInfoWireFormat3 = DataSource.ModelInfoWireFormat3 = {
        fromJson: function fromJson(wireFormat) {
            var message = _objectSpread({}, defaultModelInfo, wireFormat);
            if (wireFormat) {
                message.modelFramework = KaggleSdkModelsModelFrameworkWireFormat3.fromJson(wireFormat.modelFramework);
            }
            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.license) {
                message.license = KaggleSdkDatasetsLicenseWireFormat3.fromJson(wireFormat.license);
            }
            return message;
        }
    };
})(DataSource || (DataSource = {}));
var defaultBigqueryInfo = {};
export var BigqueryInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBigqueryInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sourceLastModifiedDate) {
            message.sourceLastModifiedDate = new Date(wireFormat.sourceLastModifiedDate);
        }
        return message;
    }
};
var defaultBigquerySnapshotInfo = {};
export var BigquerySnapshotInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBigquerySnapshotInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sourceLastModifiedDate) {
            message.sourceLastModifiedDate = new Date(wireFormat.sourceLastModifiedDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bigqueryTables) {
            message.bigqueryTables = TableCollectionWireFormat3.fromJson(wireFormat.bigqueryTables);
        }
        return message;
    }
};
var defaultBooleanMetrics = {
    trueCount: 0,
    falseCount: 0
};
export var BooleanMetricsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBooleanMetrics, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.histogram) {
            message.histogram = HistogramWireFormat3.fromJson(wireFormat.histogram);
        }
        return message;
    }
};
var defaultBooleanMetricsComputedFields = {};
export var BooleanMetricsComputedFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBooleanMetricsComputedFields, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.histogram) {
            message.histogram = HistogramWireFormat3.fromJson(wireFormat.histogram);
        }
        return message;
    }
};
var defaultColumnBaseInfo = {
    name: "",
    firestorePath: "",
    order: 0
};
export var ColumnBaseInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultColumnBaseInfo, wireFormat);
        return message;
    }
};
var defaultColumnSummaryInfo = {
    columnTypes: [],
    sampleColumnNames: [],
    totalColumnCount: 0
};
export var ColumnSummaryInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultColumnSummaryInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columnTypes) {
            message.columnTypes = wireFormat.columnTypes.map(function(i) {
                return ColumnTypeSummaryInfoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalColumnCount) {
            message.totalColumnCount = parseInt(wireFormat.totalColumnCount);
        }
        return message;
    }
};
var defaultColumnSummaryInfoComputedFields = {
    totalColumnCount: 0
};
export var ColumnSummaryInfoComputedFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultColumnSummaryInfoComputedFields, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalColumnCount) {
            message.totalColumnCount = parseInt(wireFormat.totalColumnCount);
        }
        return message;
    }
};
var defaultColumnTypeSummaryInfo = {
    columnCount: 0,
    rowCount: 0
};
export var ColumnTypeSummaryInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultColumnTypeSummaryInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columnCount) {
            message.columnCount = parseInt(wireFormat.columnCount);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rowCount) {
            message.rowCount = parseInt(wireFormat.rowCount);
        }
        return message;
    }
};
export var ColumnUpdateInfoWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.type) {
            wireFormat.type = HarmonizedDataTypeWireFormat3.toJson(message.type);
        }
        if (message === null || message === void 0 ? void 0 : message.extendedType) {
            wireFormat.extendedType = ExtendedDataTypeWireFormat3.toJson(message.extendedType);
        }
        return wireFormat;
    }
};
var defaultCompetitionInfo = {
    competitionId: 0
};
export var CompetitionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionInfo, wireFormat);
        return message;
    }
};
var defaultCompressionInfo = {
    fileSize: 0
};
export var CompressionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompressionInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileSize) {
            message.fileSize = parseInt(wireFormat.fileSize);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationLastUpdate) {
            message.creationLastUpdate = new Date(wireFormat.creationLastUpdate);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationPercentComplete) != undefined) {
            message.creationPercentComplete = Number(wireFormat.creationPercentComplete);
        }
        return message;
    }
};
var defaultContainerInfo = {
    totalChildren: 0,
    count: 0
};
export var ContainerInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultContainerInfo, wireFormat);
        return message;
    }
};
var defaultCountryMetrics = {
    counts: [],
    uniqueValueCount: 0,
    mostCommonValueCount: 0
};
export var CountryMetricsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCountryMetrics, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.counts) {
            message.counts = wireFormat.counts.map(function(i) {
                return FrequencyCountWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultCountryMetricsComputedFields = {
    mostCommonValueCount: 0
};
export var CountryMetricsComputedFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCountryMetricsComputedFields, wireFormat);
        return message;
    }
};
var defaultDatabundle = {};
export var DatabundleWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundle, DataObjectWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundleInfo) {
            message.databundleInfo = DatabundleInfoWireFormat3.fromJson(wireFormat.databundleInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetInfo) {
            message.datasetInfo = DatasetInfoWireFormat3.fromJson(wireFormat.datasetInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionInfo) {
            message.competitionInfo = CompetitionInfoWireFormat3.fromJson(wireFormat.competitionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.modelInstanceInfo) {
            message.modelInstanceInfo = ModelInstanceInfoWireFormat3.fromJson(wireFormat.modelInstanceInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.remoteDatasourceInfo) {
            message.remoteDatasourceInfo = RemoteDatasourceInfoWireFormat3.fromJson(wireFormat.remoteDatasourceInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bigqueryInfo) {
            message.bigqueryInfo = BigqueryInfoWireFormat3.fromJson(wireFormat.bigqueryInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.githubInfo) {
            message.githubInfo = GithubInfoWireFormat3.fromJson(wireFormat.githubInfo);
        }
        return message;
    }
};
var defaultDatabundleInfo = {
    creatorUserId: 0
};
export var DatabundleInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleInfo, wireFormat);
        if (wireFormat) {
            message.databundleType = KaggleSdkDatasetsDatabundleTypeWireFormat3.fromJson(wireFormat.databundleType);
        }
        if (wireFormat) {
            message.diffType = KaggleSdkDatasetsDatabundleDiffTypeWireFormat3.fromJson(wireFormat.diffType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationDate) {
            message.creationDate = new Date(wireFormat.creationDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.removalDate) {
            message.removalDate = new Date(wireFormat.removalDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.versions) {
            message.versions = DatabundleVersionCollectionWireFormat3.fromJson(wireFormat.versions);
        }
        return message;
    }
};
var defaultDatabundleOwnerCompetitionInfo = {
    competitionId: 0
};
export var DatabundleOwnerCompetitionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleOwnerCompetitionInfo, wireFormat);
        return message;
    }
};
var defaultDatabundleOwnerDatasetInfo = {
    datasetId: 0,
    datasetVersionId: 0
};
export var DatabundleOwnerDatasetInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleOwnerDatasetInfo, wireFormat);
        return message;
    }
};
var defaultDatabundleOwnerInfo = {
    databundleVersionId: 0,
    previewsDisabled: false
};
export var DatabundleOwnerInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleOwnerInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataset) {
            message.dataset = DatabundleOwnerDatasetInfoWireFormat3.fromJson(wireFormat.dataset);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competition) {
            message.competition = DatabundleOwnerCompetitionInfoWireFormat3.fromJson(wireFormat.competition);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernel) {
            message.kernel = DatabundleOwnerKernelInfoWireFormat3.fromJson(wireFormat.kernel);
        }
        return message;
    }
};
var defaultDatabundleOwnerKernelInfo = {
    kernelId: 0,
    kernelVersionId: 0
};
export var DatabundleOwnerKernelInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleOwnerKernelInfo, wireFormat);
        return message;
    }
};
export var DatabundleVerificationInfoWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDatabundleVersion = {};
export var DatabundleVersionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleVersion, DataObjectWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundleVersionInfo) {
            message.databundleVersionInfo = DatabundleVersionInfoWireFormat3.fromJson(wireFormat.databundleVersionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetVersionInfo) {
            message.datasetVersionInfo = DatasetVersionInfoWireFormat3.fromJson(wireFormat.datasetVersionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.modelInstanceVersionInfo) {
            message.modelInstanceVersionInfo = ModelInstanceVersionInfoWireFormat3.fromJson(wireFormat.modelInstanceVersionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.statusInfo) {
            message.statusInfo = StatusInfoWireFormat3.fromJson(wireFormat.statusInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.exceptionInfo) {
            message.exceptionInfo = ExceptionInfoWireFormat3.fromJson(wireFormat.exceptionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.filesetInfo) {
            message.filesetInfo = DirectoryInfoWireFormat3.fromJson(wireFormat.filesetInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.originalCompressionInfo) {
            message.originalCompressionInfo = CompressionInfoWireFormat3.fromJson(wireFormat.originalCompressionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bundleCompressionInfo) {
            message.bundleCompressionInfo = CompressionInfoWireFormat3.fromJson(wireFormat.bundleCompressionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bigquerySnapshotInfo) {
            message.bigquerySnapshotInfo = BigquerySnapshotInfoWireFormat3.fromJson(wireFormat.bigquerySnapshotInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.storageInfo) {
            message.storageInfo = StorageInfoWireFormat3.fromJson(wireFormat.storageInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileSummaryInfo) {
            message.fileSummaryInfo = FileSummaryInfoWireFormat3.fromJson(wireFormat.fileSummaryInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columnSummaryInfo) {
            message.columnSummaryInfo = ColumnSummaryInfoWireFormat3.fromJson(wireFormat.columnSummaryInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.externalCopyInfo) {
            message.externalCopyInfo = ExternalCopyInfoWireFormat3.fromJson(wireFormat.externalCopyInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.originalRemoteUrlInfo) {
            message.originalRemoteUrlInfo = OriginalRemoteUrlInfoWireFormat3.fromJson(wireFormat.originalRemoteUrlInfo);
        }
        return message;
    }
};
var defaultDatabundleVersionCollection = {};
export var DatabundleVersionCollectionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleVersionCollection, DatabundleVersionCollectionContainerInfoWireFormat3.fromJson(wireFormat));
        return message;
    }
};
var defaultDatabundleVersionCollectionContainerInfo = {
    children: []
};
export var DatabundleVersionCollectionContainerInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleVersionCollectionContainerInfo, ContainerInfoWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
            message.children = wireFormat.children.map(function(i) {
                return DatabundleVersionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultDatabundleVersionInfo = {
    versionNumber: 0,
    creatorUserId: 0,
    objectTypeCount: {}
};
export var DatabundleVersionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleVersionInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationDate) {
            message.creationDate = new Date(wireFormat.creationDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.removalDate) {
            message.removalDate = new Date(wireFormat.removalDate);
        }
        if (wireFormat) {
            message.databundleVersionType = KaggleSdkDatasetsDatabundleVersionTypeWireFormat3.fromJson(wireFormat.databundleVersionType);
        }
        return message;
    }
};
var defaultDataObject = {
    key: "",
    path: "",
    name: ""
};
export var DataObjectWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataObject, wireFormat);
        if (wireFormat) {
            message.type = ObjectTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
var defaultDatasetInfo = {
    datasetId: 0,
    isPrivate: false
};
export var DatasetInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetInfo, wireFormat);
        return message;
    }
};
var defaultDatasetVersionInfo = {
    datasetVersionId: 0
};
export var DatasetVersionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetVersionInfo, wireFormat);
        return message;
    }
};
var defaultDataSource = {
    imageUrl: "",
    sourceUrl: "",
    sourceId: 0
};
export var DataSourceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataSource, DataObjectWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundle) {
            message.databundle = DatabundleWireFormat3.fromJson(wireFormat.databundle);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundleVersion) {
            message.databundleVersion = DatabundleVersionWireFormat3.fromJson(wireFormat.databundleVersion);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastUpdated) {
            message.lastUpdated = new Date(wireFormat.lastUpdated);
        }
        if (wireFormat) {
            message.sourceType = DataSourceTypeWireFormat3.fromJson(wireFormat.sourceType);
        }
        if (wireFormat) {
            message.state = DataSourceStateWireFormat3.fromJson(wireFormat.state);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelOutputInfo) {
            message.kernelOutputInfo = KernelOutputInfoWireFormat3.fromJson(wireFormat.kernelOutputInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.modelInfo) {
            message.modelInfo = DataSource.ModelInfoWireFormat3.fromJson(wireFormat.modelInfo);
        }
        return message;
    }
};
var defaultDateTimeHistogram = {
    buckets: []
};
export var DateTimeHistogramWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDateTimeHistogram, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.buckets) {
            message.buckets = wireFormat.buckets.map(function(i) {
                return DateTimeHistogramBucketWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultDateTimeHistogramBucket = {
    index: 0,
    count: 0
};
export var DateTimeHistogramBucketWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDateTimeHistogramBucket, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.leftValue) {
            message.leftValue = new Date(wireFormat.leftValue);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rightValue) {
            message.rightValue = new Date(wireFormat.rightValue);
        }
        return message;
    }
};
var defaultDateTimeMetrics = {};
export var DateTimeMetricsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDateTimeMetrics, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.mean) {
            message.mean = new Date(wireFormat.mean);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.minimum) {
            message.minimum = new Date(wireFormat.minimum);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maximum) {
            message.maximum = new Date(wireFormat.maximum);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.histogram) {
            message.histogram = DateTimeHistogramWireFormat3.fromJson(wireFormat.histogram);
        }
        return message;
    }
};
var defaultDirectory = {};
export var DirectoryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDirectory, DataObjectWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.directoryInfo) {
            message.directoryInfo = DirectoryInfoWireFormat3.fromJson(wireFormat.directoryInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.compressionInfo) {
            message.compressionInfo = CompressionInfoWireFormat3.fromJson(wireFormat.compressionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelSessionInfo) {
            message.kernelSessionInfo = KernelSessionInfoWireFormat3.fromJson(wireFormat.kernelSessionInfo);
        }
        return message;
    }
};
var defaultDirectoryCollection = {};
export var DirectoryCollectionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDirectoryCollection, DirectoryCollectionContainerInfoWireFormat3.fromJson(wireFormat));
        return message;
    }
};
var defaultDirectoryCollectionContainerInfo = {
    children: []
};
export var DirectoryCollectionContainerInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDirectoryCollectionContainerInfo, ContainerInfoWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
            message.children = wireFormat.children.map(function(i) {
                return DirectoryWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultDirectoryInfo = {
    totalSize: 0
};
export var DirectoryInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDirectoryInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalSize) {
            message.totalSize = parseInt(wireFormat.totalSize);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.directories) {
            message.directories = DirectoryCollectionWireFormat3.fromJson(wireFormat.directories);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.files) {
            message.files = FileCollectionWireFormat3.fromJson(wireFormat.files);
        }
        return message;
    }
};
var defaultExcelInfo = {};
export var ExcelInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultExcelInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tables) {
            message.tables = TableCollectionWireFormat3.fromJson(wireFormat.tables);
        }
        return message;
    }
};
var defaultExceptionInfo = {
    warningExceptions: []
};
export var ExceptionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultExceptionInfo, wireFormat);
        return message;
    }
};
var defaultExternalCopy = {};
export var ExternalCopyWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultExternalCopy, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastCopied) {
            message.lastCopied = new Date(wireFormat.lastCopied);
        }
        if (wireFormat) {
            message.status = ExternalCopyStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastUpdate) {
            message.lastUpdate = new Date(wireFormat.lastUpdate);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.percentFinished) != undefined) {
            message.percentFinished = Number(wireFormat.percentFinished);
        }
        return message;
    }
};
var defaultExternalCopyInfo = {
    externalCopies: []
};
export var ExternalCopyInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultExternalCopyInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.externalCopies) {
            message.externalCopies = wireFormat.externalCopies.map(function(i) {
                return ExternalCopyWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultFile = {};
export var FileWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFile, DataObjectWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileInfo) {
            message.fileInfo = FileInfoWireFormat3.fromJson(wireFormat.fileInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileTableInfo) {
            message.fileTableInfo = FileTableInfoWireFormat3.fromJson(wireFormat.fileTableInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tableInfo) {
            message.tableInfo = TableInfoWireFormat3.fromJson(wireFormat.tableInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sqliteInfo) {
            message.sqliteInfo = SqliteInfoWireFormat3.fromJson(wireFormat.sqliteInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.excelInfo) {
            message.excelInfo = ExcelInfoWireFormat3.fromJson(wireFormat.excelInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.remoteUrlInfo) {
            message.remoteUrlInfo = RemoteUrlInfoWireFormat3.fromJson(wireFormat.remoteUrlInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelSessionInfo) {
            message.kernelSessionInfo = KernelSessionInfoWireFormat3.fromJson(wireFormat.kernelSessionInfo);
        }
        return message;
    }
};
var defaultFileCollection = {};
export var FileCollectionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFileCollection, FileCollectionContainerInfoWireFormat3.fromJson(wireFormat));
        return message;
    }
};
var defaultFileCollectionContainerInfo = {
    children: []
};
export var FileCollectionContainerInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFileCollectionContainerInfo, ContainerInfoWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
            message.children = wireFormat.children.map(function(i) {
                return FileWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultFileExtensionSummaryInfo = {
    extension: "",
    fileCount: 0,
    totalSize: 0
};
export var FileExtensionSummaryInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFileExtensionSummaryInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileCount) {
            message.fileCount = parseInt(wireFormat.fileCount);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalSize) {
            message.totalSize = parseInt(wireFormat.totalSize);
        }
        return message;
    }
};
var defaultFileInfo = {
    size: 0,
    fullPath: "",
    fileExtension: "",
    contentType: "",
    contentMd5: ""
};
export var FileInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFileInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.size) {
            message.size = parseInt(wireFormat.size);
        }
        return message;
    }
};
var defaultFileSummaryInfo = {
    fileTypes: [],
    sampleFileNames: [],
    totalFileCount: 0
};
export var FileSummaryInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFileSummaryInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileTypes) {
            message.fileTypes = wireFormat.fileTypes.map(function(i) {
                return FileExtensionSummaryInfoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalFileCount) {
            message.totalFileCount = parseInt(wireFormat.totalFileCount);
        }
        return message;
    }
};
var defaultFileSummaryInfoComputedFields = {
    totalFileCount: 0
};
export var FileSummaryInfoComputedFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFileSummaryInfoComputedFields, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalFileCount) {
            message.totalFileCount = parseInt(wireFormat.totalFileCount);
        }
        return message;
    }
};
var defaultFileTableInfo = {
    includesHeader: false,
    headerRow: 0
};
export var FileTableInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFileTableInfo, wireFormat);
        return message;
    }
};
var defaultFrequencyCount = {
    key: "",
    value: 0
};
export var FrequencyCountWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFrequencyCount, wireFormat);
        return message;
    }
};
export var GetDatabundleExternalChildrenRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.verificationInfo) {
            wireFormat.verificationInfo = DatabundleVerificationInfoWireFormat3.toJson(message.verificationInfo);
        }
        return wireFormat;
    }
};
var defaultGetDatabundleExternalChildrenResponse = {
    directories: [],
    files: [],
    tables: [],
    tableColumns: []
};
export var GetDatabundleExternalChildrenResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatabundleExternalChildrenResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.directories) {
            message.directories = wireFormat.directories.map(function(i) {
                return DirectoryWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.files) {
            message.files = wireFormat.files.map(function(i) {
                return FileWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tables) {
            message.tables = wireFormat.tables.map(function(i) {
                return TableWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tableColumns) {
            message.tableColumns = wireFormat.tableColumns.map(function(i) {
                return TableColumnWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetDatabundleExternalColumnsByFirestorePathRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.verificationInfo) {
            wireFormat.verificationInfo = DatabundleVerificationInfoWireFormat3.toJson(message.verificationInfo);
        }
        return wireFormat;
    }
};
var defaultGetDatabundleExternalColumnsByFirestorePathResponse = {
    columns: []
};
export var GetDatabundleExternalColumnsByFirestorePathResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatabundleExternalColumnsByFirestorePathResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columns) {
            message.columns = wireFormat.columns.map(function(i) {
                return TableColumnWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetDatabundleExternalColumnsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.verificationInfo) {
            wireFormat.verificationInfo = DatabundleVerificationInfoWireFormat3.toJson(message.verificationInfo);
        }
        return wireFormat;
    }
};
var defaultGetDatabundleExternalColumnsResponse = {
    columns: []
};
export var GetDatabundleExternalColumnsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatabundleExternalColumnsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columns) {
            message.columns = wireFormat.columns.map(function(i) {
                return ColumnBaseInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetDatabundleExternalRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.verificationInfo) {
            wireFormat.verificationInfo = DatabundleVerificationInfoWireFormat3.toJson(message.verificationInfo);
        }
        return wireFormat;
    }
};
var defaultGetDatabundleExternalResponse = {};
export var GetDatabundleExternalResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatabundleExternalResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSource) {
            message.dataSource = DataSourceWireFormat3.fromJson(wireFormat.dataSource);
        }
        return message;
    }
};
var defaultGithubInfo = {
    ownerSlug: "",
    repositorySlug: ""
};
export var GithubInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGithubInfo, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultHistogram = {
    buckets: []
};
export var HistogramWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHistogram, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.buckets) {
            message.buckets = wireFormat.buckets.map(function(i) {
                return HistogramBucketWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.type = HarmonizedDataTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
var defaultHistogramBucket = {
    index: 0,
    leftValue: 0,
    rightValue: 0,
    count: 0
};
export var HistogramBucketWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHistogramBucket, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.leftValue) != undefined) {
            message.leftValue = Number(wireFormat.leftValue);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rightValue) != undefined) {
            message.rightValue = Number(wireFormat.rightValue);
        }
        return message;
    }
};
var defaultKernelOutputInfo = {
    kernelId: 0,
    url: ""
};
export var KernelOutputInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelOutputInfo, wireFormat);
        return message;
    }
};
var defaultKernelSessionInfo = {
    kernelSessionId: 0
};
export var KernelSessionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelSessionInfo, wireFormat);
        return message;
    }
};
var defaultModelInstanceInfo = {
    modelId: 0,
    modelInstanceId: 0,
    isPrivate: false
};
export var ModelInstanceInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelInstanceInfo, wireFormat);
        return message;
    }
};
var defaultModelInstanceVersionInfo = {
    modelInstanceVersionId: 0
};
export var ModelInstanceVersionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelInstanceVersionInfo, wireFormat);
        return message;
    }
};
var defaultNumericMetrics = {
    finiteCount: 0,
    infiniteCount: 0,
    mean: 0,
    standardDeviation: 0,
    minimum: 0,
    minimumFinite: 0,
    maximum: 0,
    maximumFinite: 0,
    quantiles: []
};
export var NumericMetricsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultNumericMetrics, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.mean) != undefined) {
            message.mean = Number(wireFormat.mean);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.standardDeviation) != undefined) {
            message.standardDeviation = Number(wireFormat.standardDeviation);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.minimum) != undefined) {
            message.minimum = Number(wireFormat.minimum);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.minimumFinite) != undefined) {
            message.minimumFinite = Number(wireFormat.minimumFinite);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maximum) != undefined) {
            message.maximum = Number(wireFormat.maximum);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maximumFinite) != undefined) {
            message.maximumFinite = Number(wireFormat.maximumFinite);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.quantiles) {
            message.quantiles = wireFormat.quantiles.map(function(i) {
                return QuantileWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.histogram) {
            message.histogram = HistogramWireFormat3.fromJson(wireFormat.histogram);
        }
        return message;
    }
};
var defaultOriginalRemoteUrlInfo = {
    originalRemoteUrls: []
};
export var OriginalRemoteUrlInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultOriginalRemoteUrlInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.originalRemoteUrls) {
            message.originalRemoteUrls = wireFormat.originalRemoteUrls.map(function(i) {
                return RemoteUrlInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultQuantile = {
    point: 0,
    value: 0
};
export var QuantileWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultQuantile, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.point) != undefined) {
            message.point = Number(wireFormat.point);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.value) != undefined) {
            message.value = Number(wireFormat.value);
        }
        return message;
    }
};
var defaultRemoteDatasourceInfo = {};
export var RemoteDatasourceInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRemoteDatasourceInfo, wireFormat);
        if (wireFormat) {
            message.updateFrequency = KaggleSdkDatasetsRemoteUrlUpdateFrequencyWireFormat3.fromJson(wireFormat.updateFrequency);
        }
        return message;
    }
};
var defaultRemoteUrlInfo = {};
export var RemoteUrlInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRemoteUrlInfo, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSqliteInfo = {};
export var SqliteInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSqliteInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tables) {
            message.tables = TableCollectionWireFormat3.fromJson(wireFormat.tables);
        }
        return message;
    }
};
var defaultStatusInfo = {
    percentageCompleted: 0
};
export var StatusInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultStatusInfo, wireFormat);
        if (wireFormat) {
            message.status = KaggleSdkDatasetsDatabundleStatusWireFormat3.fromJson(wireFormat.status);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.percentageCompleted) != undefined) {
            message.percentageCompleted = Number(wireFormat.percentageCompleted);
        }
        return message;
    }
};
var defaultStorageInfo = {};
export var StorageInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultStorageInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.uploadDataLocation) {
            message.uploadDataLocation = KaggleSdkDatasetsStorageLocationWireFormat3.fromJson(wireFormat.uploadDataLocation);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rawDataLocation) {
            message.rawDataLocation = KaggleSdkDatasetsStorageLocationWireFormat3.fromJson(wireFormat.rawDataLocation);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.individualCompressedLocation) {
            message.individualCompressedLocation = KaggleSdkDatasetsStorageLocationWireFormat3.fromJson(wireFormat.individualCompressedLocation);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bundleArchiveLocation) {
            message.bundleArchiveLocation = KaggleSdkDatasetsStorageLocationWireFormat3.fromJson(wireFormat.bundleArchiveLocation);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileSystemLocation) {
            message.fileSystemLocation = KaggleSdkDatasetsStorageLocationWireFormat3.fromJson(wireFormat.fileSystemLocation);
        }
        return message;
    }
};
var defaultStringMetrics = {
    counts: [],
    uniqueValueCount: 0,
    mostCommonValueCount: 0
};
export var StringMetricsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultStringMetrics, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.counts) {
            message.counts = wireFormat.counts.map(function(i) {
                return FrequencyCountWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultStringMetricsComputedFields = {
    mostCommonValueCount: 0
};
export var StringMetricsComputedFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultStringMetricsComputedFields, wireFormat);
        return message;
    }
};
var defaultTable = {};
export var TableWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTable, DataObjectWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tableInfo) {
            message.tableInfo = TableInfoWireFormat3.fromJson(wireFormat.tableInfo);
        }
        return message;
    }
};
var defaultTableCollection = {};
export var TableCollectionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTableCollection, TableCollectionContainerInfoWireFormat3.fromJson(wireFormat));
        return message;
    }
};
var defaultTableCollectionContainerInfo = {
    children: []
};
export var TableCollectionContainerInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTableCollectionContainerInfo, ContainerInfoWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
            message.children = wireFormat.children.map(function(i) {
                return TableWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultTableColumn = {};
export var TableColumnWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTableColumn, DataObjectWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tableColumnInfo) {
            message.tableColumnInfo = TableColumnInfoWireFormat3.fromJson(wireFormat.tableColumnInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tableColumnMetrics) {
            message.tableColumnMetrics = TableColumnMetricsWireFormat3.fromJson(wireFormat.tableColumnMetrics);
        }
        return message;
    }
};
var defaultTableColumnCollection = {};
export var TableColumnCollectionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTableColumnCollection, TableColumnCollectionContainerInfoWireFormat3.fromJson(wireFormat));
        return message;
    }
};
var defaultTableColumnCollectionContainerInfo = {
    children: []
};
export var TableColumnCollectionContainerInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTableColumnCollectionContainerInfo, ContainerInfoWireFormat3.fromJson(wireFormat));
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
            message.children = wireFormat.children.map(function(i) {
                return TableColumnWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultTableColumnInfo = {};
export var TableColumnInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTableColumnInfo, wireFormat);
        if (wireFormat) {
            message.type = HarmonizedDataTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat) {
            message.extendedType = ExtendedDataTypeWireFormat3.fromJson(wireFormat.extendedType);
        }
        return message;
    }
};
var defaultTableColumnMetrics = {
    nullCount: 0,
    nonNullCount: 0,
    validCount: 0,
    invalidCount: 0,
    totalCount: 0
};
export var TableColumnMetricsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTableColumnMetrics, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.booleanMetrics) {
            message.booleanMetrics = BooleanMetricsWireFormat3.fromJson(wireFormat.booleanMetrics);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.numericMetrics) {
            message.numericMetrics = NumericMetricsWireFormat3.fromJson(wireFormat.numericMetrics);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateTimeMetrics) {
            message.dateTimeMetrics = DateTimeMetricsWireFormat3.fromJson(wireFormat.dateTimeMetrics);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.stringMetrics) {
            message.stringMetrics = StringMetricsWireFormat3.fromJson(wireFormat.stringMetrics);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.countryMetrics) {
            message.countryMetrics = CountryMetricsWireFormat3.fromJson(wireFormat.countryMetrics);
        }
        return message;
    }
};
var defaultTableColumnMetricsComputedFields = {
    totalCount: 0
};
export var TableColumnMetricsComputedFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTableColumnMetricsComputedFields, wireFormat);
        return message;
    }
};
var defaultTableInfo = {
    totalRows: 0,
    totalColumns: 0
};
export var TableInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTableInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalRows) {
            message.totalRows = parseInt(wireFormat.totalRows);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tableColumns) {
            message.tableColumns = TableColumnCollectionWireFormat3.fromJson(wireFormat.tableColumns);
        }
        return message;
    }
};
var defaultTableInfoComputedFields = {
    totalColumns: 0
};
export var TableInfoComputedFieldsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTableInfoComputedFields, wireFormat);
        return message;
    }
};
export var UpdateDatabundleMetadataExternalRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.verificationInfo) {
            wireFormat.verificationInfo = DatabundleVerificationInfoWireFormat3.toJson(message.verificationInfo);
        }
        if (message === null || message === void 0 ? void 0 : message.columns) {
            wireFormat.columns = message.columns.map(function(i) {
                return ColumnUpdateInfoWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultUpdateDatabundleMetadataExternalResponse = {};
export var UpdateDatabundleMetadataExternalResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateDatabundleMetadataExternalResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) {
            message.usabilityRating = KaggleSdkDatasetsDatasetUsabilityRatingWireFormat3.fromJson(wireFormat.usabilityRating);
        }
        return message;
    }
};
export var DataSourceState;
(function(DataSourceState) {
    DataSourceState["PUBLIC"] = "public";
    DataSourceState["PRIVATE"] = "private";
    DataSourceState["PRIVATE_BUT_VISIBLE"] = "privateButVisible";
    DataSourceState["DELETED"] = "deleted";
})(DataSourceState || (DataSourceState = {}));
export var DataSourceStateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATA_SOURCE_STATE_PUBLIC":
            default:
                return DataSourceState.PUBLIC;
            case "DATA_SOURCE_STATE_PRIVATE":
                return DataSourceState.PRIVATE;
            case "DATA_SOURCE_STATE_PRIVATE_BUT_VISIBLE":
                return DataSourceState.PRIVATE_BUT_VISIBLE;
            case "DATA_SOURCE_STATE_DELETED":
                return DataSourceState.DELETED;
        }
    }
};
export var DataSourceType;
(function(DataSourceType) {
    DataSourceType["UNSPECIFIED"] = "unspecified";
    DataSourceType["COMPETITION"] = "competition";
    DataSourceType["DATASET"] = "dataset";
    DataSourceType["NOTEBOOK"] = "notebook";
    DataSourceType["UTILITY_SCRIPT"] = "utilityScript";
    DataSourceType["NOTEBOOK_OUTPUT"] = "notebookOutput";
    DataSourceType["MODEL_INSTANCE_VERSION"] = "modelInstanceVersion";
})(DataSourceType || (DataSourceType = {}));
export var DataSourceTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATA_SOURCE_TYPE_UNSPECIFIED":
            default:
                return DataSourceType.UNSPECIFIED;
            case "DATA_SOURCE_TYPE_COMPETITION":
                return DataSourceType.COMPETITION;
            case "DATA_SOURCE_TYPE_DATASET":
                return DataSourceType.DATASET;
            case "DATA_SOURCE_TYPE_NOTEBOOK":
                return DataSourceType.NOTEBOOK;
            case "DATA_SOURCE_TYPE_UTILITY_SCRIPT":
                return DataSourceType.UTILITY_SCRIPT;
            case "DATA_SOURCE_TYPE_NOTEBOOK_OUTPUT":
                return DataSourceType.NOTEBOOK_OUTPUT;
            case "DATA_SOURCE_TYPE_MODEL_INSTANCE_VERSION":
                return DataSourceType.MODEL_INSTANCE_VERSION;
        }
    }
};
export var ExtendedDataType;
(function(ExtendedDataType) {
    ExtendedDataType["UNSPECIFIED"] = "unspecified";
    ExtendedDataType["ID"] = "id";
    ExtendedDataType["UUID"] = "uuid";
    ExtendedDataType["LATITUDE"] = "latitude";
    ExtendedDataType["LONGITUDE"] = "longitude";
    ExtendedDataType["COORDINATES"] = "coordinates";
    ExtendedDataType["COUNTRY"] = "country";
    ExtendedDataType["PROVINCE"] = "province";
    ExtendedDataType["POSTAL_CODE"] = "postalCode";
    ExtendedDataType["ADDRESS"] = "address";
    ExtendedDataType["EMAIL"] = "email";
    ExtendedDataType["URL"] = "url";
    ExtendedDataType["INTEGER"] = "integer";
    ExtendedDataType["DECIMAL"] = "decimal";
    ExtendedDataType["CITY"] = "city";
})(ExtendedDataType || (ExtendedDataType = {}));
export var ExtendedDataTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "EXTENDED_DATA_TYPE_UNSPECIFIED":
            default:
                return ExtendedDataType.UNSPECIFIED;
            case "ID":
                return ExtendedDataType.ID;
            case "UUID":
                return ExtendedDataType.UUID;
            case "LATITUDE":
                return ExtendedDataType.LATITUDE;
            case "LONGITUDE":
                return ExtendedDataType.LONGITUDE;
            case "COORDINATES":
                return ExtendedDataType.COORDINATES;
            case "COUNTRY":
                return ExtendedDataType.COUNTRY;
            case "PROVINCE":
                return ExtendedDataType.PROVINCE;
            case "POSTAL_CODE":
                return ExtendedDataType.POSTAL_CODE;
            case "ADDRESS":
                return ExtendedDataType.ADDRESS;
            case "EMAIL":
                return ExtendedDataType.EMAIL;
            case "URL":
                return ExtendedDataType.URL;
            case "INTEGER":
                return ExtendedDataType.INTEGER;
            case "DECIMAL":
                return ExtendedDataType.DECIMAL;
            case "CITY":
                return ExtendedDataType.CITY;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ExtendedDataType.UNSPECIFIED:
            case 0:
            default:
                return "EXTENDED_DATA_TYPE_UNSPECIFIED";
            case ExtendedDataType.ID:
            case 1:
                return "ID";
            case ExtendedDataType.UUID:
            case 2:
                return "UUID";
            case ExtendedDataType.LATITUDE:
            case 3:
                return "LATITUDE";
            case ExtendedDataType.LONGITUDE:
            case 4:
                return "LONGITUDE";
            case ExtendedDataType.COORDINATES:
            case 5:
                return "COORDINATES";
            case ExtendedDataType.COUNTRY:
            case 6:
                return "COUNTRY";
            case ExtendedDataType.PROVINCE:
            case 7:
                return "PROVINCE";
            case ExtendedDataType.POSTAL_CODE:
            case 8:
                return "POSTAL_CODE";
            case ExtendedDataType.ADDRESS:
            case 9:
                return "ADDRESS";
            case ExtendedDataType.EMAIL:
            case 10:
                return "EMAIL";
            case ExtendedDataType.URL:
            case 11:
                return "URL";
            case ExtendedDataType.INTEGER:
            case 12:
                return "INTEGER";
            case ExtendedDataType.DECIMAL:
            case 13:
                return "DECIMAL";
            case ExtendedDataType.CITY:
            case 14:
                return "CITY";
        }
    }
};
export var ExternalCopyStatus;
(function(ExternalCopyStatus) {
    ExternalCopyStatus["UNSPECIFIED"] = "unspecified";
    ExternalCopyStatus["STARTED"] = "started";
    ExternalCopyStatus["FINISHED"] = "finished";
})(ExternalCopyStatus || (ExternalCopyStatus = {}));
export var ExternalCopyStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "EXTERNAL_COPY_STATUS_UNSPECIFIED":
            default:
                return ExternalCopyStatus.UNSPECIFIED;
            case "EXTERNAL_COPY_STATUS_STARTED":
                return ExternalCopyStatus.STARTED;
            case "EXTERNAL_COPY_STATUS_FINISHED":
                return ExternalCopyStatus.FINISHED;
        }
    }
};
export var HarmonizedDataType;
(function(HarmonizedDataType) {
    HarmonizedDataType["STRING"] = "string";
    HarmonizedDataType["BOOLEAN"] = "boolean";
    HarmonizedDataType["NUMERIC"] = "numeric";
    HarmonizedDataType["DATE_TIME"] = "dateTime";
    HarmonizedDataType["UNKNOWN"] = "unknown";
})(HarmonizedDataType || (HarmonizedDataType = {}));
export var HarmonizedDataTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "STRING":
            default:
                return HarmonizedDataType.STRING;
            case "BOOLEAN":
                return HarmonizedDataType.BOOLEAN;
            case "NUMERIC":
                return HarmonizedDataType.NUMERIC;
            case "DATE_TIME":
                return HarmonizedDataType.DATE_TIME;
            case "UNKNOWN":
                return HarmonizedDataType.UNKNOWN;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case HarmonizedDataType.STRING:
            case 0:
            default:
                return "STRING";
            case HarmonizedDataType.BOOLEAN:
            case 1:
                return "BOOLEAN";
            case HarmonizedDataType.NUMERIC:
            case 2:
                return "NUMERIC";
            case HarmonizedDataType.DATE_TIME:
            case 3:
                return "DATE_TIME";
            case HarmonizedDataType.UNKNOWN:
            case 4:
                return "UNKNOWN";
        }
    }
};
export var ObjectType;
(function(ObjectType) {
    ObjectType[// Default/Unknown/Undetermined
    "GENERIC"] = "generic";
    ObjectType["DATABUNDLE"] = "databundle";
    ObjectType["DATABUNDLE_VERSION"] = "databundleVersion";
    ObjectType["DIRECTORY"] = "directory";
    ObjectType["FILE"] = "file";
    ObjectType["TABLE"] = "table";
    ObjectType["TABLE_COLUMN"] = "tableColumn";
    ObjectType["DATA_SOURCE"] = "dataSource";
})(ObjectType || (ObjectType = {}));
export var ObjectTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "OBJECT_TYPE_GENERIC":
            default:
                return ObjectType.GENERIC;
            case "OBJECT_TYPE_DATABUNDLE":
                return ObjectType.DATABUNDLE;
            case "OBJECT_TYPE_DATABUNDLE_VERSION":
                return ObjectType.DATABUNDLE_VERSION;
            case "OBJECT_TYPE_DIRECTORY":
                return ObjectType.DIRECTORY;
            case "OBJECT_TYPE_FILE":
                return ObjectType.FILE;
            case "OBJECT_TYPE_TABLE":
                return ObjectType.TABLE;
            case "OBJECT_TYPE_TABLE_COLUMN":
                return ObjectType.TABLE_COLUMN;
            case "OBJECT_TYPE_DATA_SOURCE":
                return ObjectType.DATA_SOURCE;
        }
    }
};
export var datasetsDatabundlesClient = {
    databundleService: {
        getDatabundleExternal: createClient(GetDatabundleExternalRequestWireFormat3, GetDatabundleExternalResponseWireFormat3, "datasets.databundles.DatabundleService/GetDatabundleExternal"),
        getDatabundleExternalChildren: createClient(GetDatabundleExternalChildrenRequestWireFormat3, GetDatabundleExternalChildrenResponseWireFormat3, "datasets.databundles.DatabundleService/GetDatabundleExternalChildren"),
        getDatabundleExternalColumns: createClient(GetDatabundleExternalColumnsRequestWireFormat3, GetDatabundleExternalColumnsResponseWireFormat3, "datasets.databundles.DatabundleService/GetDatabundleExternalColumns"),
        getDatabundleExternalColumnsByFirestorePath: createClient(GetDatabundleExternalColumnsByFirestorePathRequestWireFormat3, GetDatabundleExternalColumnsByFirestorePathResponseWireFormat3, "datasets.databundles.DatabundleService/GetDatabundleExternalColumnsByFirestorePath"),
        updateDatabundleMetadataExternal: createClient(UpdateDatabundleMetadataExternalRequestWireFormat3, UpdateDatabundleMetadataExternalResponseWireFormat3, "datasets.databundles.DatabundleService/UpdateDatabundleMetadataExternal")
    }
};
